/**
 * Opening the command palette from anywhere.
 *
 * The palette mounts once in App.jsx OUTSIDE the route/layout trees, so a
 * toolbar button cannot reach its state through props or context without
 * rewrapping both trees. A window event is the decoupled seam: any component
 * dispatches, the palette listens, and its own route/token guard still
 * decides whether anything renders.
 */

export const COMMAND_PALETTE_EVENT = 'zehn:command-palette';

export function openCommandPalette(action = 'open') {
  window.dispatchEvent(new CustomEvent(COMMAND_PALETTE_EVENT, { detail: { action } }));
}

/**
 * One-time discovery hint bookkeeping. The hint retires forever the moment
 * the palette is opened by ANY path — once someone has used the feature,
 * teaching it again is nagging.
 */
export const SEARCH_HINT_SEEN_KEY = 'docs_search_hint_seen';

export function searchHintSeen() {
  try {
    return localStorage.getItem(SEARCH_HINT_SEEN_KEY) === '1';
  } catch {
    return true; // no storage → never nag
  }
}

export function markSearchHintSeen() {
  try {
    localStorage.setItem(SEARCH_HINT_SEEN_KEY, '1');
  } catch {
    /* private browsing: the hint may reappear next session, harmless */
  }
}
